import { HttpResult } from 'widgets-for-react'

export const validateVAT = async (
  countryId: number,
  VATnumber: string
): Promise<HttpResult<boolean>> => {
  const res = await fetch(
    `/api/v1/Checkout/ValidateVAT?countryId=${countryId}&VATnumber=${VATnumber}`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: boolean = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data,
  }
}

export const EUCountriesAndUK = [
  'Nederland',
  'België',
  'Bulgarije',
  'Cyprus',
  'Denemarken',
  'Duitsland',
  'Estland',
  'Finland',
  'Frankrijk',
  'Griekenland',
  'Hongarije',
  'Ierland',
  'Italië',
  'Kroatië',
  'Litouwen',
  'Luxemburg',
  'Malta',
  'Oostenrijk',
  'Polen',
  'Portugal',
  'Roemenië',
  'Slovenië',
  'Slowakije',
  'Spanje',
  'Tsjechië',
  'Zweden',
  'Verenigd Koninkrijk',
]
